module.exports = __webpack_public_path__ + "img/daniel_penhos.67c12de1.png";